import {
  type RecommendationServiceType,
  useRecommendationConfigContext,
} from '../config'

export const useIsRecommendationWidgetIdValid = (
  widgetId: string,
  serviceId: RecommendationServiceType,
): boolean => {
  const config = useRecommendationConfigContext()

  return Boolean(
    config[serviceId] &&
    Object.values(config[serviceId]).some((item) => item.id === widgetId),
  )
}
